import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  // send contact message
  sendContactMessage: async ({ commit }, payload) => {
    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.post('/market-place/contact-us', payload)

      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data.insertContactUs,
        message: res.data.message
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  }
}